import netcoServer from '../../apis/netcoServer';
import {SEND_SIGNED_FILES_UID_MAIL} from "../types";
import handleResponse from "../helpers/handleResponse";
import _ from 'lodash';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import modalDismiss from '../modal/modalDismiss';
import loadingCall from "../helpers/loadingCall";
import load_files from "../../const/load_files";

const sendSignedFilesUIDMail= (formValues, selectedFiles) => async (dispatch, getState) => {
  const onSuccessPayload = () => {
    return infoPayload('success', load_files[getState().auth.language].files_sent_successfully);
  };
  formValues.uids =_.join(selectedFiles, ',');
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/sendSignedFilesUIDMail', formValues));
  handleResponse(dispatch, response, SEND_SIGNED_FILES_UID_MAIL, onSuccessPayload, null, [modalDismiss]);
};
export default sendSignedFilesUIDMail;